import { render, staticRenderFns } from "./COrderInfo.vue?vue&type=template&id=9df8a620&"
import script from "./COrderInfo.vue?vue&type=script&lang=js&"
export * from "./COrderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports